export default "__VITE_ASSET__b5d5fb80__"